import React, {memo} from 'react';
import {View, TouchableOpacity} from 'react-native';
import {createUseStyle} from '@redlink/assets/styles';
import {
    Text,
    Card,
    UserAvatar,
    Divider,
    Space,
} from '@redlink/components/atoms';
import {DrawerIcon, Button} from '@redlink/components/molecules';
import {useValues} from '@redlink/assets/values';
import {useLocale} from '@redlink/assets/locale';

export const PageCompactItem = memo(
    ({
         item: {fullname, avatar, pageName, defaultTab, visibleTabs = [], language},
         onSelect,
     }) => {
        const {styles, colors} = useStyle();
        const {getPageLink, staticData} = useValues();
        const {dictionary} = useLocale();
        return (
            <TouchableOpacity activeOpacity={.7} onPress={onSelect} style={styles.headerContainer}>
                <View style={styles.bodyContainer}>
                    <UserAvatar
                        source={{uri: avatar?.thumbnailUrl}}
                        style={styles.avatar}
                    />
                    <Space size={8}/>
                    <View>
                        <Text style={styles.fullnameText}>{fullname}</Text>
                        <Text style={styles.urlText} en>
                            {getPageLink(pageName)}
                        </Text>
                    </View>
                </View>
                <View style={styles.languageContainer}>
                    <Text en style={styles.langaugeText}>{language.toUpperCase()}</Text>
                </View>
            </TouchableOpacity>

        );
    }
);

const useStyle = createUseStyle(({colors, shadow, size}) => ({
    headerContainer: {
        alignItems: 'center',
        flexDirection: 'row',
        marginVertical: 8
    },
    avatar: {
        width: 24,
        height: 24,
    },
    fullnameText: {
        fontSize: 12,
        textAlign: 'left',
        color: colors.gray23,
    },
    urlText: {
        fontSize: 10,
        color: colors.gray21,
    },
    bodyContainer: {
        flex: 1,
        alignItems: 'center',
        flexDirection: 'row',
    },
    languageContainer: {
        backgroundColor: colors.gray7,
        borderRadius: 10,
        paddingHorizontal: 16,
        paddingVertical: 4,
        minWidth: 30,
        alignItems: 'center',
        justifyContent: 'center'
    },
    langaugeText: {
        fontSize: 12,
        color: colors.gray23,
    }
}));
